'use strict'

/**
 * @enum FileGasProjectTypeEng
 */
let FileGasProjectTypeEng;
(function (fileGasProjectTypeEng) {
  fileGasProjectTypeEng.None = 0
  fileGasProjectTypeEng[0] = 'None'
  // fileGasProjectTypeEng.IdCard = 1
  // fileGasProjectTypeEng[1] = 'IdCard'
  // fileGasProjectTypeEng.FirstPlan = 2
  // fileGasProjectTypeEng[2] = 'FirstPlan'  
  fileGasProjectTypeEng.DesignPlan = 11
  fileGasProjectTypeEng[11] = 'DesignPlan'
  // fileGasProjectTypeEng.Consent = 7
  // fileGasProjectTypeEng[7] = 'Consent'
  fileGasProjectTypeEng.RelatedPermit = 8
  fileGasProjectTypeEng[8] = 'RelatedPermit'
  // fileGasProjectTypeEng.EstimationSheet = 9
  // fileGasProjectTypeEng[9] = 'EstimationSheet'
  fileGasProjectTypeEng.DraftSheet = 10
  fileGasProjectTypeEng[10] = 'DraftSheet'
})(FileGasProjectTypeEng || (FileGasProjectTypeEng = {}))

export { FileGasProjectTypeEng }
